import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    translate_import_invalid_field_label,
    resolve_import_invalid_message_key,
} from '../../services/importInvalid';

const ImportInvalidMessage = ({ resource, fieldKey, code, importSource, entry }) => {
    const { t } = useTranslation();
    const label = translate_import_invalid_field_label(resource, fieldKey);
    const eventival_kind = entry?.eventival?.type || null;

    const message_key = resolve_import_invalid_message_key(resource, fieldKey, code, {
        importSource,
        eventivalKind: eventival_kind,
    });

    return (
        <li>
            <b>{ label }</b>
            {' : '}
            { t(message_key) }
        </li>
    );
};

export default ImportInvalidMessage;
